import React, { useState } from 'react';
import axios from 'axios'
import { useDispatch } from 'react-redux';
import { AiOutlineLock } from 'react-icons/ai';
import { BsFillEyeFill, BsFillEyeSlashFill } from 'react-icons/bs';
import { useNavigate } from 'react-router-dom';
import {BASE_URL, Endpoints} from '../../constants/urls';
import { ErrorAlert } from '../../components/ErrorAlert';
import { loginUser } from '../../store/authSlice';
import './styles.css';


const Login = () => {
  const dispatch = useDispatch();
  const [email, setEmail] = useState('');
  const [showPasseord, setShowPasseord] = useState(false);
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [wrongAlert, setWrongAlert] = useState(false);
  const navigate = useNavigate();
  
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    if (name === 'email') {
      setEmail(value);
    } else if (name === 'password') {
      setPassword(value);
    }
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    let data = {
      Email: email,
      Password: password,
      DeviceId: 'device',
    };
    setLoading(true);

    try {
      const url = `${BASE_URL}${Endpoints.Login}`;
      const response = await axios.post(url, data);
      localStorage.setItem('accessToken', response.data.accessToken);
      dispatch(loginUser()); 
      navigate('/admin', { replace: true });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setWrongAlert(true);
    }

  };
  return (
    <div style={{ backgroundColor: '#f7f7f7' }} className='row mx-0'>
      <div className='col-xl-8 col-lg-7 px-0 d-none d-lg-block'>
        <img
          className='loginMainImg'
          src={require('../../assets/intro-image.jpg')}
        />
      </div>
      <div className='col-xl-4 col-lg-5 loginSide px-0 col-12'>
        <div>
          <div className='text-center pt-5'>
            <img
              src={require('../../assets/app-logo.png')}
              width='230'
            />
          </div>
          <form className='form m-md-5 m-3 text-start'>
            <div className='row justify-content-center'>
              <div className='col-12 col-sm-8 col-lg-12'>
                <div className='loginForm p-4'>
                  <div className='form-group mb-3 position-relative '>
                    <svg
                      viewBox='64 64 896 896'
                      focusable='false'
                      data-icon='mail'
                      width='1em'
                      height='1em'
                      fill='currentColor'
                      aria-hidden='true'
                      color='red'
                    >
                      <path d='M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 110.8V792H136V270.8l-27.6-21.5 39.3-50.5 42.8 33.3h643.1l42.8-33.3 39.3 50.5-27.7 21.5zM833.6 232L512 482 190.4 232l-42.8-33.3-39.3 50.5 27.6 21.5 341.6 265.6a55.99 55.99 0 0068.7 0L888 270.8l27.6-21.5-39.3-50.5-42.7 33.2z'></path>
                    </svg>
                    <label className='mb-1'>Email</label>
                    <input
                      style={{ background: '#e7f0fe', border: 'none' }}
                      className='reidInputForm'
                      placeholder='Enter your email'
                      type='text'
                      name='email'
                      value={email}
                      onChange={handleInputChange}
                    />
                  </div>
                  <label className='mb-1'>Password</label>
                  <div className='reidInputFormPass mb-3 d-flex'>
                    <div
                      style={{
                        width: '10%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        textAlign: 'center',
                      }}
                    >
                      <AiOutlineLock size={20} style={{ marginRight: -5 }} />
                    </div>
                    <div
                      style={{
                        width: '80%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        textAlign: 'center',
                        background: '#e7f0fe',
                      }}
                    >
                      <input
                        style={{
                          border: 'none',
                          width: '100%',
                          height: 45,
                          background: '#e7f0fe',
                          borderWidth: 0,
                        }}
                        className='form-control'
                        placeholder='Enter your password'
                        type={showPasseord ? 'text' : 'password'}
                        name='password'
                        value={password}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div
                      style={{
                        width: '10%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        textAlign: 'center',
                      }}
                      onClick={() => {
                        setShowPasseord(!showPasseord);
                      }}
                      className=' d-flex justify-content-right'
                    >
                      {showPasseord ? (
                        <BsFillEyeFill color={'#2aa2db'} />
                      ) : (
                        <BsFillEyeSlashFill />
                      )}
                    </div>
                  </div>
                  <button
                    onClick={handleSubmit}
                    className='loginBtn btn w-100 mt-2'
                  >
                    {loading ? (
                      <span
                        className='spinner-grow spinner-grow-sm mr-1 ml-1'
                        role='status'
                        aria-hidden='true'
                      ></span>
                    ) : (
                      ' login'
                    )}
                  </button>
                </div>
              </div>
            </div>

            {/* <text onClick={()=>navigate('/home', { replace: true })} style={{width:120}}>signup</text> */}
          </form>
        </div>
      </div>

      {wrongAlert && (
        <ErrorAlert
          message='Please enter the correct email or password'
          onClose={() => {
            setWrongAlert(false);
          }}
        />
      )}
    </div>
  );
};
export default Login;
